import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Paper,
  CircularProgress,
  Button,
  ListItemIcon,
  LinearProgress,
} from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import { callApi } from 'src/core/callApi';
import { COLOR_BACKGROUND_1, COLOR_BACKGROUND_2, COLOR_PRIMARY_2 } from 'src/colors';

const ExportMonitor = () => {
  const [statusUpdates, setStatusUpdates] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchUpdates = async () => {
    setLoading(true);
    try {
      const url =
        'https://l8q69lzrxc.execute-api.us-east-2.amazonaws.com/default/dataExportHandler';
      const config = {
        queryParams: {
          operation: 'poll',
        },
      };
      const response = await callApi(url, config, false);
      console.log('Response:', response);

      if (response.message) {
        const data = response.message;
        setStatusUpdates(prevUpdates => [...prevUpdates, ...data.status_updates]);
      }
    } catch (error) {
      console.error('Error fetching status updates:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Progress Monitor
      </Typography>
      <Paper
        sx={{
          p: 2,
          height: '65vh',
          overflow: 'scroll',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.5)',
        }}
      >
        {loading && <LinearProgress />}
        <List>
          {statusUpdates.map((update, index) => (
            <ListItem
              key={index}
              style={{
                backgroundColor: index % 2 === 0 ? COLOR_BACKGROUND_1 : COLOR_BACKGROUND_2,
              }}
            >
              <ListItemIcon>
                <ArrowRightIcon />
              </ListItemIcon>
              <ListItemText primary={update} />
            </ListItem>
          ))}
        </List>
      </Paper>
      <Button
        onClick={fetchUpdates}
        sx={{ color: COLOR_PRIMARY_2, marginTop: 2 }}
        disabled={loading == true}
      >
        {loading ? 'Loading newer events...' : 'Fetch latest status'}{' '}
        <CloudSyncIcon sx={{ marginLeft: 2 }} />
      </Button>
    </Box>
  );
};

export default ExportMonitor;
